 /*
 *
 * TermsPage constants
 *
 */
export const FETCH_TERMS_REQUEST = 'src/TermsPage/FETCH_TERMS_REQUEST';
export const FETCH_TERMS_FAILURE = 'src/TermsPage/FETCH_TERMS_FAILURE';
export const FETCH_TERMS_SUCCESS = 'src/TermsPage/FETCH_TERMS_SUCCESS';



// WEBPACK FOOTER //
// ./src/containers/TermsPage/constants.js